<template>
  <UserProfile />
</template>

<script>
import UserProfile from '@/components/user/UserProfile.vue';

export default {
  name: "UserProfilePage",
  components: {
    UserProfile,
  },
};
</script>

<style scoped>
/* Add any necessary styling here */
</style>